<template>
  <h3
    class="mb-1 flex justify-between items-end relative"
    :class="large ? 'text-xs text-gray-300' : 'text-2xs text-gray-400'"
  >
    <span class="uppercase font-semibold"><slot /></span>
    <slot name="action" />
  </h3>
</template>

<script setup>
  defineProps({
    large: Boolean
  });
</script>

